import React from 'react';
import { Landmark } from 'lucide-react';
import { PageTransition } from '@/components/motion';
import Card from '@/components/UI/Card';

function FundManager() {
  return (
    <PageTransition className="p-6">
      <Card>
        <div className="text-center py-20">
          <Landmark className="w-12 h-12 text-muted-foreground/30 mx-auto mb-3" />
          <h2 className="text-xl font-bold text-foreground mb-2">Fund Manager</h2>
          <p className="text-sm text-muted-foreground max-w-md mx-auto">
            Multi-broker portfolio management. Allocate capital across brokers,
            track aggregate performance, and optimize fund-level risk.
          </p>
          <p className="text-xs text-muted-foreground/60 mt-4">Coming soon</p>
        </div>
      </Card>
    </PageTransition>
  );
}

export default FundManager;
